import { buildBindable } from '@monofe/di';
import type { IZip } from '@monofe/util';
import { bindZip, injectZip, TYPES, unbindZip } from '@monofe/util';
import zip from './zip';

export default buildBindable<IZip>({
    id: TYPES.IZip,
    bind: bindZip,
    remove: unbindZip,
    inject: injectZip,
    build: () => Promise.resolve(zip),
});
